/**
 * PP Mobile Header Menu — alineación con el cart icon.
 *
 * El hamburguesa está absolute-positioned dentro del header. Para que
 * quede EXACTAMENTE al mismo Y que el cart icon (que vive en
 * .header__icons), leemos la posición real del icons-wrapper y aplicamos
 * top inline al hamburger.
 *
 * Robusto frente a: viewport sizes, sticky-header reveals, dynamic logo
 * height, language toggles, etc.
 */

(function () {
  const MOBILE_MAX = 749;

  function align() {
    const trigger = document.querySelector('.pp-mobile-menu-trigger');
    if (!trigger) return;

    // Only run on mobile viewports — desktop hides the trigger anyway.
    if (window.innerWidth > MOBILE_MAX) {
      trigger.style.removeProperty('top');
      return;
    }

    const headerIcons = document.querySelector('.header__icons');
    const parent = trigger.offsetParent;
    if (!headerIcons || !parent) return;

    const iconsRect = headerIcons.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    // Find the y-center of the icons row, expressed as offset within parent.
    const iconsCenterY = iconsRect.top + iconsRect.height / 2 - parentRect.top;
    const triggerHeight = trigger.offsetHeight;

    trigger.style.top = `${iconsCenterY - triggerHeight / 2}px`;
  }

  function init() {
    align();
    window.addEventListener('resize', align);
    // sticky-header reveals/hides on scroll change the visual position;
    // realign on scroll (passive, cheap).
    window.addEventListener('scroll', align, { passive: true });
    // Some browsers paint fonts late; one delayed realignment catches that.
    window.setTimeout(align, 200);
    window.setTimeout(align, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
